import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import type { UseProviderPageHeaderActions } from '@openx/components-provider/lib/utils/context/ProviderHookTypes';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useProviderDeleteModal } from './useProviderDeleteModal';

export const useProviderPageHeaderActions: UseProviderPageHeaderActions = ({ id, name }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleDeleteProvider = useProviderDeleteModal();

  return useMemo(
    (): ActionButtonProps[] => [
      {
        color: 'secondary',
        'data-test': 'edit-action-button',
        label: t('Edit'),
        onClick: () => {
          navigate(`/providers/${id}/edit`);
        },
        showAsActionButton: true,
      },
      {
        color: 'error',
        'data-test': 'delete-action-button',
        label: t('Delete'),
        onClick: () => handleDeleteProvider({ id, name }),
        showAsActionButton: true,
      },
    ],
    [id, handleDeleteProvider, name, navigate, t]
  );
};
